import { IconButton } from "@mui/material";

import { useAnalytics } from "@/providers";
import { ZoomInIcon as ZoomIn } from "@/shared/foundation/icons/mui";

import { ZoomMode } from "../messaging/commands";
import { usePlotPanelContext } from "../panelContext";

import { AxisConstraintBadge } from "./AxisConstraintBadge";

const nextZoomMode: Record<ZoomMode, ZoomMode> = {
  x: "xy",
  xy: "y",
  y: "x",
};

export function ZoomTool() {
  const { trackEvent } = useAnalytics();
  const { zoomMode, setZoomMode } = usePlotPanelContext();
  const onClick = () => {
    const next = nextZoomMode[zoomMode];
    trackEvent("PlotPanelZoomModeChanged", { zoomMode: next });
    setZoomMode(next);
  };

  return (
    <IconButton
      aria-label="chart-zoom-axis"
      onClick={onClick}
      size="small"
      title="Change zoom axis"
    >
      <AxisConstraintBadge axisConstraint={zoomMode}>
        <ZoomIn fontSize="small" color="primary" />
      </AxisConstraintBadge>
    </IconButton>
  );
}
